<template>
    <div class='liquidation'>
        <bread-crumb :list="[{
            url: '/main/dataCenter',
            text: '数据中心'
        }, {
            url: '/main/dataCenter/nav/fundReconciliation',
            text: '资金对账'
        }, {
            text: '清算记录'
        }]"/>
        <div class="liquidation-header">
            <date-picker v-model="datePickerValue" @change="datePickerChange"/>
        </div>
        <el-table v-loading="isLoading"
            ref="elTable"
            :data="liquidationData"
            :height="'calc(100vh - 191px)'"
            :empty-text="isLoading ? ' ' : '暂无数据'">
            <el-table-column
                label="清算日"
                width="120">
                <template v-slot="{ row }">
                    <p>{{ judgeDate(row.settlement_date) }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="在线支付净收款(元)"
                min-width="160"
                align="right">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper v-numberAlign>{{ row.settlement_all }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="手续费率"
                prop="pay_amount"
                min-width="90"
                align="right">
                <template v-slot="{ row }">
                    <p>{{ row.commission_rate }}%</p>
                </template>
            </el-table-column>
            <el-table-column
                label="手续费(元)"
                min-width="90"
                align="right">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper v-numberAlign>{{ row.fee }}</p>
                </template>
            </el-table-column>
            <el-table-column
                label="结算金额(元)"
                min-width="120"
                align="right">
                <template v-slot="{ row }">
                    <p class="text-popper" v-textPopper v-numberAlign>{{ row.settlement_amount }}</p>
                </template>
            </el-table-column>
            <el-table-column min-width="20"/>
            <el-table-column
                label="清算状态"
                width="130">
                <template v-slot:header="{ row }">
                    <span>清算状态</span>
                    <question-icon :popperWidth="372" :iconClass="'_tooltips_goods_detail_'">
                        <div style="line-height: 18px">
                            <p>说明：</p>
                            <p>1.仅展示扫呗通道清算记录</p>
                            <p>2.到账时间一般为D+1(第二天到账)，因清算机构差异，可能存在T+1(下一工作日到账)</p>
                            <p>3.因清算机构差异，同一天应入账款可能存在分多次到账的情况</p>
                            <p>4.如遇到划款失败请联系森果客服：400-027-0135 进行处理</p>
                        </div>
                    </question-icon>
                </template>
                <template v-slot="{ row }">
                    <p style="{ color: row.settlement_status === 2 ? '#ee5b5b' : '#333';  }" class="text-popper" v-textPopper>{{ getSettlementMsg(row.settlement_status) }}</p>
                </template>
            </el-table-column>
            <p v-if="liquidationData.length > 0 && !isLoading" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
            <!-- <p v-if="isHasMore && _isLoading" slot="append" style="text-align: center; padding: 10px;">
                <span class="loading-step-animation">正在加载...</span>
            </p> -->
            <!-- <p v-if="(!(isHasMore && _isLoading)) && liquidationData.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p> -->
        </el-table>
    </div>
</template>

<script lang='ts'>
import DatePicker from '@/components/date_picker/date_picker.vue'
import BreadCrumb from '@/components/bread_crumb/bread_crumb.vue'
import QuestionIcon from '@/components/question_icon/question_icon.vue'
import { createComponent, ref, Ref, onBeforeMount, onMounted, SetupContext } from '@vue/composition-api'
import { openMessage } from '@/utils/system.tsx'
import { getOneMonthValue } from '@/utils/index'
import $fetch from '@/api'
import dayjs from 'dayjs'
import clone from 'lodash/cloneDeep'
import { setObjectItemToFixed } from '@/utils/index'

export default createComponent({
    setup(props, ctx) {
        const datePickerValue: Ref<any> = ref(getOneMonthValue())
        const liquidationData = ref([])
        const isLoading = ref(false)
        // const { page: oPage, isLoading: _isLoading, isHasMore, bindListener, initScrollLoad } = useScrollLoad()
        // not reactive data and methods
        let oLimit: number = 20
        let oFromDate: string = ''
        let oToDate: string = ''

        const format = (t?: string) => dayjs(t).format('YYYY-MM-DD')

        // 组件的入口
        onBeforeMount(() => {
            oLimit = 20
            oFromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
            oToDate = format()
            isLoading.value = true
            getLiquidationData()
                .then(() => isLoading.value = false)
        })

        // onMounted(() => {
        //     bindListener({
        //         dom: (ctx.refs.elTable as any).$el.querySelector('.el-table__body-wrapper'),
        //         loadFunction: getLiquidationData
        //     })
        // })

        const getLiquidationData = (fromDate = oFromDate, toDate = oToDate) => {
            return $fetch.post({
                url: '/finance/getlcswsettlementhistory',
                params: {
                    from_date: fromDate,
                    to_date: toDate
                }
            }).then(data => {
                console.log('清算记录', clone(data))
                data = setObjectItemToFixed(data, { ignore: ['commission_rate'] })
                data.forEach(item => {
                    item.settlement_all = (+item.fee + +item.settlement_amount).toFixed(2)
                    item.commission_rate = (item.commission_rate * 100).toFixed(2)
                })
                liquidationData.value = data
                // if (page === 1) {
                //     fundData.value = data.orders
                //     initScrollLoad(data)
                // } else {
                //     fundData.value = fundData.value.concat(data.orders)
                // }
                return data
            }).catch(e => openMessage('error', e.message || '获取清算记录失败'))
        }

        // date picker change事件
        const datePickerChange = () => {
            if (datePickerValue.value === null) {
                // 清空的情况
                oFromDate = dayjs().subtract(1, 'month').format('YYYY-MM-DD')
                oToDate = format()
            } else {
                oFromDate = format(datePickerValue.value[0])
                oToDate = format(datePickerValue.value[1])
            }
            isLoading.value = true
            getLiquidationData()
                .then(() => isLoading.value = false)
        }

        const getSettlementMsg = (status) => {
            switch (status) {
                case 1:
                    return '划款成功'
                case 2:
                    return '划款失败'
                case 3:
                    return '划款中'
                case 4:
                    return '已发起划款，状态未知'
                default:
                    return '未知类型'
            }
        }

        const judgeDate = (d) => {
            const today = dayjs()
            const yesterday = dayjs().subtract(1, 'day')
            const dObj = dayjs(d)
            if (dObj.isSame(today, 'day')) {
                return '今日'
            }
            if (dObj.isSame(yesterday, 'day')) {
                return '昨日'
            }
            return d
        }

        return {
            // data
            isLoading,
            datePickerValue,
            liquidationData,
            // methods
            datePickerChange,
            getSettlementMsg,
            judgeDate
        }
    },
    components: {
        BreadCrumb,
        DatePicker,
        QuestionIcon
    }
})
</script>

<style lang="scss">
._tooltips_goods_detail_ {
    width: 372px;
}
</style>

<style lang="scss" scoped>
.liquidation-header {
    margin: 8px 0;
    font-size: 14px;
}
</style>